var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#'+_vm.marker.id),expression:"'#'+marker.id"}],attrs:{"href":'#'+_vm.marker.id},on:{"click":function($event){$event.preventDefault();return _vm.scrollToMarker.apply(null, arguments)}}},[_c('div',{staticClass:"bullet",style:({backgroundColor:_vm.marker.color})}),_vm._v("\n    "+_vm._s(_vm.marker.name)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62534c42","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CategoryListItem.vue
// module id = 439
// module chunks = 0